module.exports = __webpack_public_path__ + "img/caprock_m.9362e157.png";